const OFFCANVAS_BASE_SELECTOR: string = "[data-off-canvas-wrapper]";
const OFFCANVAS_SELECTOR: string = "[data-off-canvas]";
const OFFCANVAS_BUTTON_SELECTOR: string = "[data-off-canvas-button]";
const OFFCANVAS_OVERLAY_SELECTOR: string = ".js-off-canvas-overlay";
const OFFCANVAS_LINK_SELECTOR: string = ".nav__anchor";
const OFFCANVAS_CONTENT_SELECTOR: string = ".off-canvas-content";

const OFFCANVAS_OVERLAY_CLOSE_CLASSNAME: string = "is-closable";
const OFFCANVAS_OVERLAY_OPEN_CLASSNAME: string = "is-visible";
const OFFCANVAS_OPEN_CLASSNAME: string = "is-open";
const OFFCANVAS_CLOSE_CLASSNAME: string = "is-closed";
const OFFCANVAS_POSITION_CLASSNAME: string = "is-open-right";
const OFFCANVAS_POSITION2_CLASSNAME: string = "has-open-right";
const OFFCANVAS_PUSH_CLASSNAME: string = "has-transition-push";

export class OffcanvasUI {
  public constructor(private $base: HTMLElement) {
  }

  public checkOffcanvasState(callback) {
    this.$base.querySelector(OFFCANVAS_BUTTON_SELECTOR).addEventListener('click', () => {
      document.body.classList.add('disable-scroll');
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.add(OFFCANVAS_OPEN_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.remove(OFFCANVAS_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_OVERLAY_SELECTOR).classList.add(OFFCANVAS_OVERLAY_OPEN_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_OVERLAY_SELECTOR).classList.add(OFFCANVAS_OVERLAY_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_CONTENT_SELECTOR).classList.add(OFFCANVAS_POSITION_CLASSNAME, OFFCANVAS_PUSH_CLASSNAME, OFFCANVAS_POSITION2_CLASSNAME);

      callback();
    });
  }

  public checkScrollState() {
    document.querySelector(OFFCANVAS_OVERLAY_SELECTOR).addEventListener('click', () => {
      document.body.classList.remove('disable-scroll');
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.add(OFFCANVAS_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.remove(OFFCANVAS_OPEN_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_OVERLAY_SELECTOR).classList.remove(OFFCANVAS_OVERLAY_OPEN_CLASSNAME, OFFCANVAS_OVERLAY_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_CONTENT_SELECTOR).classList.remove(OFFCANVAS_POSITION_CLASSNAME, OFFCANVAS_PUSH_CLASSNAME, OFFCANVAS_POSITION2_CLASSNAME);
    });

    document.querySelector(OFFCANVAS_LINK_SELECTOR).addEventListener('click', () => {
      document.body.classList.remove('disable-scroll');
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.add(OFFCANVAS_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_SELECTOR).classList.remove(OFFCANVAS_OPEN_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_OVERLAY_SELECTOR).classList.remove(OFFCANVAS_OVERLAY_OPEN_CLASSNAME, OFFCANVAS_OVERLAY_CLOSE_CLASSNAME);
      this.$base.querySelector(OFFCANVAS_CONTENT_SELECTOR).classList.remove(OFFCANVAS_POSITION_CLASSNAME, OFFCANVAS_PUSH_CLASSNAME, OFFCANVAS_POSITION2_CLASSNAME);
    });
  }
}

export function createOffcanvasUI() {
  const $base = document.querySelectorAll(OFFCANVAS_BASE_SELECTOR);
  let uiInstances: OffcanvasUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new OffcanvasUI(element));
  }

  return uiInstances;
}
